import React,{Component} from 'react'
import './Home.css';
import Product from './Product.js';

class Home extends Component {
    state={
        products:[
            {id:1,title:'title2',image:'assets/accessories.jpg',price:10,rating:3},
            {id:2,title:'title1',image:'assets/jeans.jpg',price:23.4,rating:4},
            {id:3,title:'title3',image:'assets/shoes.jpg',price:73.48,rating:2},
            {id:4,title:'title4',image:'assets/tops.png',price:53.4,rating:4},
            {id:5,title:'title5',image:'assets/soludos.jpg',price:443.4,rating:5},
            {id:6,title:'title6',image:'assets/book.jpg',price:213.54,rating:1},
        ],
    };
    render(){
        return (
            <div className="home">
                     <div className="home__container py-5" style={{backgroundImage:`url(assets/home.jpg)`}}>
                     <div className="home__content py-5">
                            <h1 className="home__content__headerOne">
                               simple way to shop <br/> a unique products
                            </h1>
                            <p className="home__content__pargraphOne">
                                fast..easy..security..unique
                            </p>
                            <a href="#" className="btn btn-danger rounded-pill home__content__brand">
                                BUY
                            </a>
                            <p className="home__content__pargraphTwo">from your home </p>
                        </div>
                     </div>

                     <div className="homeBanner">
                         <img src={"assets/home1.jpg"}
                         alt="shop banner" 
                         className="homeBanner__image"/>
                     </div>
                     
                     <div className="home__row">
                         <Product products={this.state.products[0]}/>
                         <Product products={this.state.products[1]}/>
                     </div>
                     <div className="home__row">
                         <Product products={this.state.products[2]}/>
                         <Product products={this.state.products[3]}/>
                         <Product products={this.state.products[4]}/>
                     </div>
                     <div className="home__row">
                         <Product products={this.state.products[5]}/>
                     </div>
                     
            </div>
    
        )
    }
    
}

export default Home;
